<template>
  <div class="image-viewer-background" @click="closeModal">
    <transition name="fade" mode="in">
      <div class="content-container" :key="`image-modal-${currentImage}`">
        <button class="modal-button" id="close-modal" @click="$emit('close')">
          <Icon id="close" />
        </button>
        <button v-if="images.length > 1" class="modal-button" id="back-image" @click="lastImage">
          <Icon id="arrow" />
        </button>
        <button v-if="images.length > 1" class="modal-button" id="next-image" @click="nextImage">
          <Icon id="arrow" />
        </button>
        <div class="image-container">
          <img
            class="modal-image"
            :src="images[currentImage ?? 0].image.original"
            :alt="images[currentImage ?? 0].description"
          />
        </div>
        <span class="image-description">{{ images[currentImage ?? 0].description }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SectionQuote',
  props: {
    images: {
      type: Object,
      required: true,
    },
    image: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentImage: 0,
    }
  },
  methods: {
    nextImage() {
      if (this.currentImage >= this.images.length - 1) {
        this.currentImage = 0
      } else {
        this.currentImage++
      }
    },
    lastImage() {
      if (this.currentImage <= 0) {
        this.currentImage = this.images.length - 1
      } else {
        this.currentImage--
      }
    },
    closeModal(e) {
      const backButton = document.getElementById('back-image')
      const nextButton = document.getElementById('next-image')
      const contentContainer = document.querySelector('.content-container')

      if (
        !backButton?.contains(e.target) &&
        !nextButton?.contains(e.target) &&
        !contentContainer?.contains(e.target)
      ) {
        this.$emit('close')
      }
    },
  },
  mounted() {
    this.currentImage = this.image
  },
}
</script>
